/**
 * 将魔力变化值规整为最终入账整数。
 *
 * 节点内部允许使用浮点数计算倍率、随机范围和持续加成，但魔力作为最终资源值
 * 必须在写入本轮魔力和总魔力前统一整数化。这里使用对称四舍五入，避免
 * `Math.round` 对负数半值偏向 0，也避免向下取整系统性削弱正收益或放大负收益。
 *
 * @param value 节点或基础产出计算出的原始魔力变化。
 * @returns 可写入战斗状态的整数魔力变化；非有限数会被视为 0。
 */
export function normalizeMagicDelta(value: number): number {
    if (!Number.isFinite(value) || value === 0) return 0;
    return Math.sign(value) * Math.round(Math.abs(value));
}
